import styled from 'styled-components';
import sizes from 'utils/screenSizes';

export const ContainerDelivery = styled.div`
  position: relative;

  width: 100%;
  height: 100%;

  background-image: ${({ banner }) => (banner ? `url(${banner})` : 'none')};
  background-repeat: no-repeat;
  background-size: cover;

  @media (min-width: ${sizes.notebook}) {
    min-height: 768px;
  }

  @media all and (max-width: ${sizes.notebook}) {
    display: none;
  }
`;
export const Content = styled.div`
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0px;
  left: 0px;
  h1 {
    font-family: 'ChickenSansBold';
    font-style: normal;
    font-weight: bold;
    font-size: 64px;
    line-height: 22px;
    text-align: center;
    color: #FF7D00;
    margin-top: 70px;
    padding-top: 40px;
  }

  p {
    margin-top: 60px;
    font: 'ChickenSansExtraLight'; !important;
    color: #FF7D00;
    font-size: 20px;
    line-height: 29px;
    text-align: center;
  }

  .partners {
    display: flex;
    flex-direction: row;
    justify-content: center;
    margin-top: 60px;
  }

  a {
    border: none;
    border-radius: 6px;
    outline: none;
    cursor: pointer;
    max-width: 100px;
    max-height: 308px;
  }

  #uber {
    position: relative;
    min-width: 287px;
    max-width: 287px;
    height: 308px;
    margin-left: 0px;
    margin-right: 17.5px;
    background-color: #000000;

    .logo {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      margin-left: auto;
      margin-right: auto;
      margin-top: 30px;
      width: 165px;
    }

    .link {
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
      margin-left: auto;
      margin-right: auto;
      margin-bottom: 30px;
      width: 50px;
    }
  }

  #ifood {
    position: relative;
    min-width: 287px;
    max-width: 287px;
    height: 308px;
    margin-left: 17.5px;
    margin-right: 17.5px;
    background-color: #ed1722;

    .logo {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      margin-left: auto;
      margin-right: auto;
      margin-top: 35px;
      width: 204px;
    }

    .link {
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
      margin-left: auto;
      margin-right: auto;
      margin-bottom: 30px;
      width: 50px;
    }
  }

  #rappi {
    position: relative;
    min-width: 287px;
    max-width: 287px;
    height: 308px;
    background-color: #fd6250;

    .logo {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      margin-left: auto;
      margin-right: auto;
      margin-top: 30px;
      width: 175px;
    }

    .link {
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
      margin-left: auto;
      margin-right: auto;
      margin-bottom: 30px;
      width: 50px;
    }
  }

  #plk-delivery {
    position: relative;
    min-width: 287px;
    max-width: 287px;
    height: 308px;
    background-color: #FF7D00;

    .logo {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      margin-left: auto;
      margin-right: auto;
      margin-top: 30px;
      width: 175px;
    }

    .link {
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
      margin-left: auto;
      margin-right: auto;
      margin-bottom: 30px;
      width: 50px;
    }
  }
`;
